import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAggregationDropdown, createAllDataLabelVisibilityCheckboxForStackedCharts, createAutoSetBarWidthCheckbox, createAxisGridlinesFormatter, createAxisGridlinesVisibilityCheckbox, createAxisIntervalsFormatter, createAxisIntervalsVisibilityCheckbox, createAxisNameFontFormatter, createAxisNameTextInput, createAxisNameVisibilityCheckbox, createAxisValueLabelFontFormatter, createAxisValueLabelMaxCharactersInput, createAxisValueLabelNumberFormatter, createAxisValueLabelVisibilityCheckbox, createAxisVerticalPositionControl, createAxisVisibilityCheckbox, createBarPaddingLabelledView, createBarWidthLabelledView, createChartBackgroundColorFormatter, createChartColumnNumberFormatter, createChartConditionalFormatter, createChartSortFormat, createChartZoomComponent, createColumnColorPicker, createColumnDataColorsPicker, createColumnNameTextInput, createDataLabelAlignmentDropdown, createDataLabelBackgroundFormatter, createDataLabelFilterDropdown, createDataLabelFontFormatter, createDataLabelMaxLengthInput, createDataLabelNumericFilter, createDataLabelVisibilityCheckbox, createGroupPaddingLabelledView, createHideNullValuesCheckbox, createLegendEnabledCheckbox, createLegendPositionComponent, createMaxDataPointsInput, createPlotAreaBackgroundColorFormatter, createResponsiveLayoutCheckbox, createShowNullAsZeroCheckbox, createShowTotalLabelsCheckbox, createStackedAsPercentCheckbox, createStackedAsPercentNumberFormatter, createStackLabelBackgroundFormatter, createStackLabelFontFormatter, createStackLabelMaxLengthInput, createTimeBucketDropdown, createTooltipBackgroundFormatter, createTooltipContentFormatter, createTooltipFieldLabelFormatter, createTooltipFontFormatter, createTooltipVisibilityCheckbox, createYAxisNumberRangeInput, } from '../schema-composer-utils/common-elements';
import { shouldHideAxisSettings, shouldHideDataLabelsAccordion, shouldHideTooltipSettings, } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createBackgroundImageEditor, createSection, } from '../schema-composer-utils/elements';
const columnSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createColumnDataColorsPicker(),
                                    createChartSortFormat(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createShowNullAsZeroCheckbox(),
                                    createAggregationDropdown(),
                                    createColumnColorPicker(),
                                    createChartConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                    createColumnDataColorsPicker(),
                                    createHideNullValuesCheckbox(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const legendSettings = [
    createSection({
        children: [
            createLegendEnabledCheckbox(),
            createLegendPositionComponent(),
        ],
    }),
];
const dataLabelSettings = [
    createSection({
        children: [createAllDataLabelVisibilityCheckboxForStackedCharts()],
        isChartProperty: true,
    }),
    createSection({
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        properties: {
                            header: 'charts.chartEditor.SHOW_TOTAL_LABELS',
                        },
                        children: [
                            createShowTotalLabelsCheckbox(),
                            createStackLabelFontFormatter(),
                            createStackLabelMaxLengthInput(),
                            createStackLabelBackgroundFormatter(),
                        ],
                        translate: ['header'],
                    }),
                ],
            }),
        ],
        isChartProperty: true,
    }),
    createSection({
        isHiddenCallback: shouldHideDataLabelsAccordion,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        key: 'columnName',
                        isAnswerProperty: true,
                        runTimeProperties: {
                            header: 'TS_INPUT',
                        },
                        children: [
                            createDataLabelVisibilityCheckbox(),
                            createDataLabelFilterDropdown(),
                            createDataLabelNumericFilter(),
                            createDataLabelFontFormatter(),
                            createDataLabelMaxLengthInput(),
                            createDataLabelAlignmentDropdown(),
                            createDataLabelBackgroundFormatter(),
                        ],
                    }),
                ],
            }),
        ],
    }),
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createTooltipBackgroundFormatter(),
            createTooltipFieldLabelFormatter(),
            createTooltipFontFormatter(),
        ],
        isHiddenCallback: shouldHideTooltipSettings,
    }),
];
const displaySettings = [
    createSection({
        children: [
            createResponsiveLayoutCheckbox(),
            createStackedAsPercentCheckbox(),
            createStackedAsPercentNumberFormatter(),
            createAutoSetBarWidthCheckbox(),
            createBarWidthLabelledView(),
            createBarPaddingLabelledView(),
            createGroupPaddingLabelledView(),
            createMaxDataPointsInput(),
            createChartZoomComponent(),
        ],
    }),
    createSection({
        isAdvanced: true,
        children: [
            createAccordion({
                children: [
                    createAccordionItem({
                        properties: {
                            header: 'Background',
                        },
                        children: [
                            createChartBackgroundColorFormatter(),
                            createPlotAreaBackgroundColorFormatter(),
                            createBackgroundImageEditor(),
                        ],
                    }),
                ],
            }),
        ],
    }),
];
const axisSettings = [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis name',
                                },
                                children: [
                                    createAxisNameVisibilityCheckbox(),
                                    createAxisNameTextInput(),
                                    createAxisNameFontFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Value label',
                                },
                                children: [
                                    createAxisValueLabelVisibilityCheckbox(),
                                    createAxisValueLabelNumberFormatter(),
                                    createAxisValueLabelFontFormatter(),
                                    createAxisValueLabelMaxCharactersInput(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis lines',
                                },
                                children: [
                                    createAxisGridlinesVisibilityCheckbox(),
                                    createAxisGridlinesFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Intervals',
                                },
                                children: [
                                    createAxisIntervalsVisibilityCheckbox(),
                                    createAxisIntervalsFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAxisVisibilityCheckbox(),
                    createAxisVerticalPositionControl(),
                    createYAxisNumberRangeInput(),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis name',
                                },
                                children: [
                                    createAxisNameVisibilityCheckbox(),
                                    createAxisNameTextInput(),
                                    createAxisNameFontFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Value label',
                                },
                                children: [
                                    createAxisValueLabelVisibilityCheckbox(),
                                    createAxisValueLabelNumberFormatter(),
                                    createAxisValueLabelFontFormatter(),
                                    createAxisValueLabelMaxCharactersInput(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis lines',
                                },
                                children: [
                                    createAxisGridlinesVisibilityCheckbox(),
                                    createAxisGridlinesFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Intervals',
                                },
                                children: [
                                    createAxisIntervalsVisibilityCheckbox(),
                                    createAxisIntervalsFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [createAxisVisibilityCheckbox()],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis name',
                                },
                                children: [
                                    createAxisNameVisibilityCheckbox(),
                                    createAxisNameTextInput(),
                                    createAxisNameFontFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Value label',
                                },
                                children: [
                                    createAxisValueLabelVisibilityCheckbox(),
                                    createAxisValueLabelFontFormatter(),
                                    createAxisValueLabelMaxCharactersInput(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                properties: {
                                    header: 'Axis lines',
                                },
                                children: [
                                    createAxisGridlinesVisibilityCheckbox(),
                                    createAxisGridlinesFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            createSection({
                isHiddenCallback: shouldHideAxisSettings,
                isAdvanced: true,
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'intervals',
                                properties: {
                                    header: 'Intervals',
                                },
                                children: [
                                    createAxisIntervalsVisibilityCheckbox(),
                                    createAxisIntervalsFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
export const stackedBarSchema = {
    [ChartSettingsV2MenuItems.COLUMN]: columnSettings,
    [ChartSettingsV2MenuItems.AXIS]: axisSettings,
    [ChartSettingsV2MenuItems.DATA_LABEL]: dataLabelSettings,
    [ChartSettingsV2MenuItems.TOOLTIP]: tooltipSettings,
    [ChartSettingsV2MenuItems.LEGEND]: legendSettings,
    [ChartSettingsV2MenuItems.DISPLAY]: displaySettings,
};
//# sourceMappingURL=stacked-bar-schema.js.map